import { TOGGLE_STATIC } from '../constants/ActionTypes'
import update from 'react/lib/update'

const initialState = {
  staticVersion: false
};

export default function config(state = initialState, action) {

  switch (action.type) {
    case TOGGLE_STATIC:
      var isStatic = (action.override) ? action.override : !state.staticVersion;
      var newState = Object.assign({}, state, { staticVersion: isStatic } );
      return newState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./styleguide/reducers/config.js